import { render, staticRenderFns } from "./PredictionComparison.vue?vue&type=template&id=3da8d2c6&scoped=true"
import script from "./PredictionComparison.vue?vue&type=script&lang=js"
export * from "./PredictionComparison.vue?vue&type=script&lang=js"
import style0 from "./PredictionComparison.vue?vue&type=style&index=0&id=3da8d2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da8d2c6",
  null
  
)

export default component.exports